// types.ts
var AssertionError = class extends TypeError {
  constructor(message) {
    super(message);
  }
};
AssertionError.prototype.name = "AssertionError";
function typeName(what) {
  if (what === null) return "null";
  const type = typeof what;
  if (type !== "object") return type;
  if (Array.isArray(what)) return `array[length=${what.length}]`;
  const prototype = Object.getPrototypeOf(what);
  if (!prototype) return "object[null prototype]";
  if (prototype.constructor === Object) return "object";
  if (!prototype.constructor) return "object[unknown]";
  if (!prototype.constructor.name) return "object[anonymous]";
  return `"${prototype.constructor.name}"`;
}
export {
  AssertionError,
  typeName
};
//# sourceMappingURL=types.mjs.map
